export default __webpack_public_path__ + "static/media/service6.88d675ca.png";